import { render, staticRenderFns } from "./RatingHistogram.vue?vue&type=template&id=e08e46c0"
import script from "./RatingHistogram.vue?vue&type=script&lang=js"
export * from "./RatingHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports